import { store } from "../../store/store";

export const checkPermissions = permissions => {
	const storedPermissions = store.getState().auth.permissions;
	const found = storedPermissions.some(r => permissions.indexOf(r) >= 0);
	if (found) {
		return true;
	}
	return false;
};
